<template>
    <v-card elevation="0" class="pa-4">
        <div class="d-flex justify-center">
            <v-btn @click="setDefault()" color="success" outlined small>
                Por defecto
            </v-btn>
        </div>
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-0"
            :footer-props="footer_props"
            hide-default-footer
        >
            <template v-slot:item.porcentaje_maximo="{ item }">
                <v-text-field
                    v-if="
                        item.factor_corrector == null &&
                        item.porcentaje_maximo == null
                    "
                    label="Porcentaje"
                    type="number"
                    v-model="porcentaje_maximo"
                    :error-messages="
                        porcentaje_maximo &&
                        (porcentaje_maximo < 0 ||
                            porcentaje_maximo > MAX_PORCENTAJE)
                            ? 'El valor debe estar comprendido entre 0 y 999'
                            : ''
                    "
                >
                    <template v-slot:append>
                        <v-tooltip
                            v-if="items.length >= 2"
                            bottom
                            max-width="470px"
                            color="grey darken-3"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="setPorcentajeMax"
                                >
                                    mdi-arrow-up-bold-box
                                </v-icon>
                            </template>
                            <span>Máximo</span>
                        </v-tooltip>
                    </template>
                </v-text-field>
                <div class="d-flex justify-center align-self-center" v-else>
                    {{
                        `${
                            item.porcentaje_maximo < MAX_PORCENTAJE
                                ? '< '
                                : '> '
                        }${
                            item.porcentaje_maximo == MAX_PORCENTAJE
                                ? items[items.length - 3].porcentaje_maximo
                                : item.porcentaje_maximo
                        } %`
                    }}
                </div>
            </template>
            <template v-slot:item.factor_corrector="{ item }">
                <v-text-field
                    v-if="
                        item.factor_corrector == null &&
                        item.porcentaje_maximo == null
                    "
                    label="Factor"
                    type="number"
                    v-model="factor_corrector"
                    :error-messages="
                        factor_corrector && factor_corrector < 0
                            ? 'El valor debe ser mayor que 0'
                            : ''
                    "
                ></v-text-field>
                <div class="d-flex justify-center align-self-center" v-else>
                    {{ item.factor_corrector }}
                </div>
            </template>
            <template v-slot:item.add="{ item, index }">
                <v-icon
                    :disabled="
                        (porcentaje_maximo &&
                            factor_corrector &&
                            factor_corrector < 0) ||
                        porcentaje_maximo < 0 ||
                        porcentaje_maximo > MAX_PORCENTAJE
                    "
                    v-if="
                        item.factor_corrector == null &&
                        item.porcentaje_maximo == null
                    "
                    @click="addEntry()"
                    color="success"
                    >mdi-pen-plus</v-icon
                >
                <v-icon v-else @click="deleteEntry(index)" color="red"
                    >mdi-pen-minus</v-icon
                >
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { clone } from '@/util/libUtil.js';

export default {
    data: () => ({
        DEFAULT_FACTOR: {
            0: {
                porcentaje_maximo: 85,
                factor_corrector: 0.0,
            },
            1: {
                porcentaje_maximo: 100,
                factor_corrector: 0.85,
            },
            2: {
                porcentaje_maximo: 110,
                factor_corrector: 1.0,
            },
            3: {
                porcentaje_maximo: 125,
                factor_corrector: 1.1,
            },
            4: {
                porcentaje_maximo: 150,
                factor_corrector: 1.2,
            },
            5: {
                porcentaje_maximo: 999,
                factor_corrector: 2.0,
            },
            6: {
                porcentaje_maximo: null,
                factor_corrector: null,
            },
        },
        MAX_PORCENTAJE: 999,
        porcentaje_maximo: '',
        factor_corrector: '',
        headers: [
            {
                text: 'Porcentaje Máximo',
                value: 'porcentaje_maximo',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Factor Corrector',
                value: 'factor_corrector',
                align: 'center',
                sortable: false,
            },
            { text: '', value: 'add', align: 'center', sortable: false },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [-1],
        },
        items: [{ porcentaje_maximo: null, factor_corrector: null }],
    }),
    methods: {
        clone,
        setDefault() {
            this.porcentaje_maximo = '';
            this.factor_corrector = '';
            // this.items = this.DEFAULT_FACTOR;
            // Efectivamente lo repocesamos para que el factor sea un json en bd en lugar de un array
            let array = [];
            // Move for values in DEFAULT_FACTOR and push in array
            for (let key in this.DEFAULT_FACTOR) {
                array.push(this.DEFAULT_FACTOR[key]);
            }
            this.items = array;

            delete this.DEFAULT_FACTOR[6];
            this.correctiveFactor.factor_details = clone(this.DEFAULT_FACTOR);
            this.DEFAULT_FACTOR[6] = {
                porcentaje_maximo: null,
                factor_corrector: null,
            };
        },
        setPorcentajeMax() {
            this.porcentaje_maximo = this.MAX_PORCENTAJE;
        },
        deleteEntry(index) {
            this.items.splice(index, 1);

            // Efectivamente lo repocesamos para que el factor sea un json en bd en lugar de un array
            let factObj = {};
            this.items.forEach((element, index) => {
                if (element.porcentaje_maximo && element.factor_corrector)
                    factObj[index] = {
                        ['factor_corrector']: element.factor_corrector,
                        ['porcentaje_maximo']: element.porcentaje_maximo,
                    };
            });

            this.correctiveFactor.factor_details = factObj;
        },
        addEntry() {
            if (this.porcentaje_maximo && this.factor_corrector) {
                let item = {
                    porcentaje_maximo: Number(this.porcentaje_maximo),
                    factor_corrector: Number(this.factor_corrector).toFixed(2),
                };

                // La ordenasión
                for (let i = 0; i < this.items.length; i++) {
                    if (
                        this.items[i].porcentaje_maximo == null ||
                        this.items[i].porcentaje_maximo > item.porcentaje_maximo
                    ) {
                        this.items.splice(i, 0, item);
                        break;
                    }
                }

                this.porcentaje_maximo = '';
                this.factor_corrector = '';

                // Efectivamente lo repocesamos para que el factor sea un json en bd en lugar de un array
                let factObj = {};
                this.items.forEach((element, index) => {
                    if (element.porcentaje_maximo && element.factor_corrector)
                        factObj[index] = {
                            ['factor_corrector']: element.factor_corrector,
                            ['porcentaje_maximo']: element.porcentaje_maximo,
                        };
                });

                this.correctiveFactor.factor_details = factObj;
            }
        },
    },
    computed: {
        correctiveFactor: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .correctiveFactor.form;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/correctiveFactor',
                    value
                );
            },
        },
        ...mapState('areaPersonal/calculadora', {
            isOpenCorrectiveFactor: (state) => state.correctiveFactor.isOpen,
        }),
    },
    watch: {
        isOpenCorrectiveFactor: {
            immediate: true,
            handler: function (newValue) {
                if (!newValue) {
                    this.items = [
                        { porcentaje_maximo: null, factor_corrector: null },
                    ];
                }
            },
        },
    },
};
</script>